import api from '@/services/api/config';
import status from './status';
import typ from './typ';
import gruppe from './gruppe';
import ausfuehrung from './ausfuehrung';
import historie from './historie';
import settings from './settings';
import werkzeugbau from './werkzeugbau';
import eingangspruefung from './eingangspruefung';
import standort from './standort';

const path = 'v1/werkzeug';

export default {
  get: (page, size, sort = null, desc = false, suche = null, sucheKunde = null, werkzeugtyp = null, statusParam = null, status2 = null, werkzeugbauParam = null, funktionspruefungVorgemerkt = false, funktionspruefungFaellig = false) => api.get(path, {
    params: {
      page,
      size,
      sort,
      desc,
      suche,
      werkzeugtyp,
      status: statusParam,
      sucheKunde,
      status2,
      werkzeugbau: werkzeugbauParam,
      funktionspruefung_vorgemerkt: funktionspruefungVorgemerkt,
      funktionspruefung_faellig: funktionspruefungFaellig,
    },
  }),
  getById: (id) => api.get(`${path}/${id}`),
  getAnzahlStatus: () => api.get(`${path}/anzahl`),
  getByWerkzeugnummer: (werkzeugnummer) => api.get(`${path}/by-werkzeugnummer/${werkzeugnummer}`),
  getByArtikel: (artikelnummer) => api.get(`${path}/by-artikel/${artikelnummer}`),
  getWechselleinsaetze: (id) => api.get(`${path}/${id}/wechseleinsatz`),
  getHistorie: (id, page, size, sort = null, desc = false) => api.get(`${path}/${id}/historie`, {
    params: {
      page, size, sort, desc,
    },
  }),
  addHistorie: (id, formData) => api.post(`${path}/${id}/historie`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  }),
  changeHistorie: (werkzeugId, historieId, formData) => api.put(`${path}/${werkzeugId}/historie/${historieId}`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  }),
  deleteHistorie: (werkzeugId, historieId) => api.delete(`${path}/${werkzeugId}/historie/${historieId}`),
  getDokumente: (id, page, size, sort = null, desc = false, typParam = null, suche = null) => api.get(`${path}/${id}/dokument`, {
    params: {
      page, size, sort, desc, typ: typParam, suche,
    },
  }),
  create: (werkzeug) => api.post(path, werkzeug),
  update: (id, werkzeug) => api.put(`${path}/${id}`, werkzeug),
  addDocument: (id, formData) => api.post(`${path}/${id}/dokument`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  }),
  werkzeugbauFertigstellen: (id) => api.patch(`${path}/${id}/werkzeugbau_fertigstellen`),
  standort,
  status,
  typ,
  gruppe,
  ausfuehrung,
  historie,
  settings,
  werkzeugbau,
  eingangspruefung,
  importCsv: (formdata) => api.post(`${path}/import`, formdata, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  }),
  werkzeugnummerExists: (werkzeugnummer, id) => api.get(`${path}/nummerexists`, { params: { werkzeugnummer, id } }),
  getArtikel: (id) => api.get(`${path}/${id}/artikel`),
  addArtikel: (id, artikel) => api.post(`${path}/${id}/artikel`, artikel),
  updateArtikel: (werkzeugId, artikelId, artikel) => api.put(`${path}/${werkzeugId}/artikel/${artikelId}`, artikel),
  removeArtikel: (werkzeugId, artikelId) => api.delete(`${path}/${werkzeugId}/artikel/${artikelId}`),
  getKuerzlichAbgeschlossen: (page, size, sort = null, desc = false) => api.get(`${path}/kuerzlich_abgeschlossen`, {
    params: {
      page, size, sort, desc,
    },
  }),
  getAnzahlKuerzlichAbgeschlossen: () => api.get(`${path}/kuerzlich_abgeschlossen/anzahl`),
  ausKuerzlichAbgeschlossenentfernen: (id) => api.delete(`${path}/kuerzlich_abgeschlossen/${id}`),
  getAnzahlAngebotserstellung: () => api.get(`${path}/angebotserstellung/anzahl`),

  getNester: (id) => api.get(`${path}/${id}/nest`),
  addNest: (id, nest) => api.post(`${path}/${id}/nest`, nest),
  updateNest: (werkzeugId, nestId, nest) => api.put(`${path}/${werkzeugId}/nest/${nestId}`, nest),
  removeNest: (werkzeugId, nestId) => api.delete(`${path}/${werkzeugId}/nest/${nestId}`),
  getNesterByArtikel: (artikelnummer) => api.get(`${path}/by-artikel/${artikelnummer}/nest`),
};
